import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import TraficLight from '../components/traficLight'
import CustomizeAll from '../components/сustomize-all/'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

import {
  YandexMarketIcon,
  YandexDirectIcon,
  GoogleAdsIcon,
  VkIcon,
  FbIcon,
  AccountIdentifierIcon,
  AccountWaitIcon,
  AccountAlertIcon,
  AddItemIcon,
  CriteoIcon,
  DinRemIcon,
  MyTargetIcon,
} from '../components/app-icon/Icons'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },

  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
    transition: 'background-color .2s linear',
    '&:hover': {
      backgroundColor: 'rgb(255, 204, 0, 0.2)',
    },
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
    '&:hover': {
      backgroundColor: 'rgb(255, 59, 48, 0.2)',
    },
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
  listChanel: {
    maxWidth: 300,
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: 30,
    marginTop: 70,
    padding: 0,
    listStyleType: 'none',
    flexWrap: 'wrap',
  },
  ChanelItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    marginRight: 30,
    marginBottom: 30,
    borderRadius: '100%',
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
  },
  ChanelIcon: {
    width: 35,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ChanelStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    position: 'absolute',
    bottom: 0,
    right: -7,
    width: 24,
    height: 24,
    border: 'solid 1px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'rgb(255, 255, 255)',
    cursor: 'pointer',
  },
  ChanelAddIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  ChanelRemoveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 13,
    height: 13,
  },
  active: {
    border: 'solid 1px #8866ff',
    boxShadow: '0 0 8px 0 #8866ff80',
    '& span': {
      border: 'solid 1px #8866ff',
      boxShadow: '0 0 8px 0 #8866ff80',
    },
  },
  titleList: {
    margin: '32px 0 32px 32px',
  },
})

class Sources extends Component {
  state = {
    site: window.state.site,
    dataSources: window.state.dataSources,
    inactiveDataSources: window.state.inactiveDataSources,
    errorMessage: window.state.errorMessage,
  }

  getCampaignsFilterString(campaignsFilter) {
    let stringArr = []
    for (let i in campaignsFilter) {
      stringArr.push(campaignsFilter[i].name)
    }
    if (stringArr.length > 3) {
      return stringArr.splice(0, 3).join(', ') + ' ...'
    }

    return stringArr.join(', ');
  }

  render() {
    const { classes } = this.props
    const { site, dataSources, inactiveDataSources, errorMessage } = this.state

    const icon = type => {
      switch (type) {
        case 'yandex_market':
          return <YandexMarketIcon className={classes.ChanelIcon} />
        case 'yandex_direct':
          return <YandexDirectIcon className={classes.ChanelIcon} />
        case 'google_ads':
          return <GoogleAdsIcon className={classes.ChanelIcon} />
        case 'vkontakte':
          return <VkIcon className={classes.ChanelIcon} />
        case 'criteo':
          return <CriteoIcon className={classes.ChanelIcon} />
        case 'dinrem':
          return <DinRemIcon className={classes.ChanelIcon} />
        case 'facebook':
          return <FbIcon className={classes.ChanelIcon} />
        case 'mytarget':
          return <MyTargetIcon className={classes.ChanelIcon} />
        default:
          break
      }
    }

    const statusSymbol = type => {
      switch (type) {
        case 'wait':
          return <AccountWaitIcon className={classes.chanelStatusIcon} />
        case 'ok':
          return <AccountIdentifierIcon className={classes.chanelStatusIcon} />
        case 'error':
          return <AccountAlertIcon className={classes.chanelStatusIcon} />
        default:
          break
      }
    }

    const action = status => {
      switch (status) {
        case 'inactive':
          return <AddItemIcon className={classes.ChanelAddIcon} />
        case 'active':
          return <OkIcon className={classes.ChanelRemoveIcon} />
        default:
          break
      }
    }

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              <TraficLight />
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <div style={{ width: 400 }}>
                <Typography variant="body1" className={classes.titleList}>
                  Автоматическая передача расходов из рекламных площадок в
                  Google Analytics
                </Typography>
                {errorMessage ? (
                  <p
                    style={{
                      paddingLeft: 32,
                      fontSize: 14,
                      color: 'red',
                    }}
                  >
                    {errorMessage}
                  </p>
                ) : null}
                <ul className={classes.chanelList}>
                  {dataSources.items.map(source => {
                    return (
                      <li key={source.hash}>
                        <a
                          href={source.settingsUrl}
                          className={cx(classes.chanel, {
                            [classes.chanelError]: source.status === 'error',
                          })}
                        >
                          <div style={{ width: 36, height: 36 }}>
                            {icon(source.type)}
                          </div>
                          <ul className={classes.chanelInfo}>
                            <li className={classes.chanelTitle}>
                              {source.displayName}
                            </li>
                            <li
                              className={cx(classes.chanelStatus, {
                                [classes.chanelStatusError]:
                                  source.status === 'error',
                              })}
                            >
                              {source.statusText}
                              {['yandex_direct', 'google_ads'].indexOf(source.type) > -1 && !source.hasAuthError ? (
                                <span
                                  style={{ display: 'block', marginTop: 5 }}
                                >
                                  {source.campaignsFilter ? (
                                    <div>Данные по затратам будут получены по выбранным кампаниям: {this.getCampaignsFilterString(source.campaignsFilter)}</div>
                                  ) : (
                                    <div>Данные по затратам будут получены по всем кампаниям.</div>
                                  )}
                                </span>
                              ) : null}
                            </li>
                          </ul>
                          {statusSymbol(source.status)}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </div>

              <ul className={classes.listChanel}>
                {inactiveDataSources.map(
                  ({ addUrl, settingsUrl, type, status }, i) => (
                    <li
                      key={i}
                      className={cx(classes.ChanelItem, {
                        [classes.active]: status === 'active',
                      })}
                    >
                      <a href={status === 'inactive' ? addUrl : settingsUrl}>
                        {icon(type)}
                        <span className={classes.ChanelStatus}>
                          {action(status)}
                        </span>
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Sources)
